import { calendarDay, dateStringAtDay } from './calendar-day.js';

function dateDay(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return NaN;
  const day = calendarDay(value);
  return Number.isFinite(day) && dateStringAtDay(day) === value ? day : NaN;
}

/** Display-only dates: never assign a proposed schedule while rendering. */
export function getGanttTaskRange(node, today = new Date()) {
  if (node.startDate || node.endDate) {
    const startDay = dateDay(node.startDate);
    const endDay = dateDay(node.endDate);
    return Number.isFinite(startDay) && Number.isFinite(endDay) && endDay >= startDay
      ? { startDay, endDay, placeholder: false } : null;
  }
  const createdDay = node.createdAt ? calendarDay(node.createdAt) : NaN;
  const startDay = Number.isFinite(createdDay) ? createdDay : calendarDay(today);
  return { startDay, endDay: startDay + 6, placeholder: true };
}
